import { FC, ChangeEvent, useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import Block from "../../components/Block.component";
import { Button, Col, DropdownItem, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { Add, Close, Dashboard, Delete, Logout, Search } from "@mui/icons-material";
import colors from "../../config/Colors.config";
import Swal from "sweetalert2";
import Cookies from 'universal-cookie';
import DeviceConfig from "../../config/Device.config";
import UsuarioModel from "../../models/Usuario.model";
import Tiempo from "../../tools/Tiempo.tool";
import Fecha from "../../tools/Fecha.tool";
import ComponentsCSS from "../../assets/css/Components.css";
import { IconButton } from "@mui/material";
import Response from "../../interfaces/Response.interface";
import ConsultaService from "../../services/Consulta.service";
import Table, { TableColumn } from 'react-data-table-component';
import iconGoogleDocs from "../../assets/icons/google-docs.png";
import Consulta from "../../interfaces/Consulta.interface";
import ConsultaModel from "../../models/Consulta.model";
import SEPOMEXService from "../../services/SEPOMEX.service";
import { Estado, Localidad, MedioAtencion } from "../../interfaces/SEPOMEX.interface";
import Producto from "../../interfaces/Producto.interface";
import Causa from "../../interfaces/Causa.interface";
import Numero from "../../tools/Number.tool";
import Ciudad from "../../interfaces/Ciudad.interface";
const cookies = new Cookies();

interface Trimestre { IdTrimestre: number, trimestre: string }
interface NA { index: number, label: string }

const ConsultasIndex: FC = () => {

    const [device, setDevice] = useState(DeviceConfig.getData());
    const [consultasLista, setConsultasLista] = useState<Consulta[]>([]);
    const [consulta, setConsulta] = useState<Consulta>(ConsultaModel.getEstructura());
    const [isOpenModalConsulta, setIsOpenModalConsulta] = useState<boolean>(false);
    const [fechaInicial, setFechaInicial] = useState<string>(Fecha.getDateToDay());
    const [fechaFinal, setFechaFinal] = useState<string>(Fecha.getDateToDay());
    const [productosLita, setProductosLista] = useState<Producto[]>([]);
    const [causasLista, setCausaLista] = useState<Causa[]>([]);
    // const [consultaLabel, setConsultaLabel] = useState<string>("");

    const [estadosLista, setEstadosLista] = useState<Estado[]>([]);
    const [ciudadesLista, setCiudadesLista] = useState<Ciudad[]>([]);
    const [localidadLista, setLocalidadLista] = useState<Localidad[]>([]);
    const [mediosAtencionLista, setMediosAtencion] = useState<MedioAtencion[]>([]);
    const [arrayErrors, setArrayErrors] = useState<string[]>([]);
    const [isOpenModalErrors, setIsOpenModalErrors] = useState<boolean>(false);
    const [labelUltimaActualizacion, setLabelUltimaActualizacion] = useState<string>(Tiempo.getCurrentTimeFormat12Hour());

    const listaTrimestre: Trimestre[] = [
        {
            IdTrimestre: 1,
            trimestre: "1er Trimestre (1 de enero al 31 de marzo)"
        },
        {
            IdTrimestre: 2,
            trimestre: "2do Trimestre (1 de abril al 30 de junio)"
        },
        {
            IdTrimestre: 3,
            trimestre: "3er Trimestre (1 de julio al 30 de septiembre)"
        },
        {
            IdTrimestre: 4,
            trimestre: "4to Trimestre (1 de octubre al 31 de diciembre)"
        },
    ]

    const lista: NA[] = [
        { index: 1, label: "UNE" },
        { index: 2, label: "Sucursal" },
        { index: 3, label: "Centro de atención telefónica" },
        { index: 4, label: "Oficinas de atención" },
    ]


    const columnsConsulta: TableColumn<Consulta>[] = [
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > FOLIO </Label>,
            cell: (consulta: Consulta) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{consulta.consultasFolio}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > ESTADO </Label>,
            cell: (consulta: Consulta) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{consulta.estadoDescripcion}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > FECHA </Label>,
            cell: (consulta: Consulta) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{Fecha.formatoSimple(consulta.consultasFecRecepcion)}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > MUNICIPIO </Label>,
            cell: (consulta: Consulta) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{consulta.municipioDescripcion}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > NIVEL DE ATENCIÓN O CONTACTO </Label>,
            cell: (consulta: Consulta) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{consulta.nivelAtencionDescripcion}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > PRODUCTO </Label>,
            cell: (consulta: Consulta) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{consulta.productoDescripcion}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} > CAUSA </Label>,
            cell: (consulta: Consulta) => <Label style={{ color: colors.negro, fontSize: 16, whiteSpace: 'normal' }} >{consulta.causaDescripcion}</Label>,
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 18 }} >  </Label>,
            cell: (consulta: Consulta) =>
                <>
                    <IconButton
                        onClick={() => eliminarConsulta(consulta)}
                    >
                        <Delete style={{ color: colors.rojo }} />
                    </IconButton>
                    <IconButton
                        onClick={() => {
                            setIsOpenModalConsulta(true)
                            setConsulta(consulta);
                            listarProductosLista();
                            listarCausasProductosLista(consulta.producto);
                        }}
                    >
                        <img style={{ width: 23 }} src={iconGoogleDocs} alt="/*-" />
                    </IconButton>
                </>,
        },
    ];

    useEffect(() => {
        cargarDatos();
        listarEstadosLista();
        getMediosAtencionLista();
        listarProductosLista();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleConsultaData = (name: string, value: string | number): void => {
        setConsulta((prev: Consulta) => ({ ...prev, [name]: value }));
    }

    const listarEstadosLista = async (): Promise<void> => {
        const response: Response = await SEPOMEXService.getEstadosLista();
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const estadosLista: Estado[] = value;
            setEstadosLista(estadosLista);
        }
    }

    const listarCiudades = async (IdEstado: number): Promise<void> => {
        const response: Response = await SEPOMEXService.getCiudadesLista(IdEstado);
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const ciudadesLista: Ciudad[] = value;
            setCiudadesLista(ciudadesLista);
        }
    }

    const listarLocalidad = async (IdEstado: number, IdCiudad: number): Promise<void> => {
        const response: Response = await SEPOMEXService.getLocalidadLista(IdEstado, IdCiudad);
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const localidadesLista: Localidad[] = value;
            setLocalidadLista(localidadesLista);
        }
    }

    const getMediosAtencionLista = async (): Promise<void> => {
        const response: Response = await SEPOMEXService.getMediosAtencionLista();
        const { error } = response;
        if (error === true) {
            toast.error("Error.");
        } else {
            const { data: { value } } = response;
            const mediosAtencionLista: MedioAtencion[] = value;
            setMediosAtencion(mediosAtencionLista);
        }
    }


    const cargarDatos = async (): Promise<void> => {

        setDevice(DeviceConfig.getData());

        if (UsuarioModel.getToken().length > 0) {
            const fechaInicial: string = Fecha.getDateToDay();
            const fechaFinal: string = Fecha.getDateToDay();
            listarConsultas(fechaInicial, fechaFinal);
        } else {
            document.body.innerHTML = "<body></body>";
            Swal.fire({
                icon: "warning",
                title: "Acceso denegado",
                text: `Tienes que iniciar sesión para poder usar el sistema`,
                showConfirmButton: true,
                confirmButtonColor: colors.dorado01,
                confirmButtonText: "Ir al login",
                timerProgressBar: true,
                reverseButtons: true,
                timer: 10000
            }).then(async (response) => {
                if (response.isConfirmed) window.location.href = "/"
            });
            Tiempo.sleep(10).then(() => window.location.href = "/");
        }

    }

    const listarConsultas = async (fechaInicial: string, fechaFinal: string): Promise<void> => {
        const response: Response = await ConsultaService.listar(fechaInicial, fechaFinal);
        const { error } = response;
        if (error === false) {
            const { data: { value } } = response;
            const consultasLista: Consulta[] = value;
            setConsultasLista(consultasLista);
            setLabelUltimaActualizacion(Tiempo.getCurrentTimeFormat12Hour());
        } else {
            toast.error("Error");
        }
    }

    const listarProductosLista = async (): Promise<void> => {
        const response: Response = await ConsultaService.listarProductos();
        if (response.error === true) {
            toast.error("Error");
        } else {
            const productosLista: Producto[] = response.data.value ?? [];
            setProductosLista(productosLista);
        }
    };

    const listarCausasProductosLista = async (IdProducto: string): Promise<void> => {
        const response: Response = await ConsultaService.causaListarProductos(IdProducto);
        if (response.error === true) {
            toast.error("Error");
        } else {
            const causasLista: Causa[] = response.data.value ?? [];
            setCausaLista(causasLista);
        }
    };

    const eliminarConsulta = async (consulta: Consulta): Promise<void> => {

        Swal.fire({
            icon: "question",
            title: "Eliminar consulta",
            text: `¿Estas seguro de eliminar esta consulta con folio: ${consulta.consultasFolio}?`,
            showConfirmButton: true,
            confirmButtonColor: colors.rojo,
            showCancelButton: true,
            cancelButtonText: "No, Eliminar",
            confirmButtonText: "Si, Eliminar",
            timerProgressBar: true,
            reverseButtons: true,
        }).then(async (response) => {
            if (response.isConfirmed) {
                await ConsultaService.eliminar(consulta.IdConsulta);
                // await REDECOServices.eliminarQueja(queja.quejasFolio);
                toast.success("Consulta eliminada");
                listarConsultas(fechaInicial, fechaFinal);
            }
        });
    };

    const enviarConsulta = async (): Promise<void> => {
        const value: { value: boolean, arrayErrors: string[] } = ConsultaModel.validarDatosConsulta(consulta);
        if (value.value) {
            const response: Response = await ConsultaService.guardar(consulta);
            if (response.error === true) { toast.error("Error"); } else { toast.success("Consulta Guardada"); listarConsultas(fechaInicial, fechaFinal); }
            setIsOpenModalConsulta(false);
        } else {
            setArrayErrors(value.arrayErrors);
            setIsOpenModalErrors(true);
        }
    }

    return (
        <section>
            <ToastContainer limit={3} position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
            <Block height={70} />

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5 }} >
                <Col style={{ textAlign: "left" }} >
                    <Dashboard style={{ marginRight: 10, color: colors.dorado01 }} />
                    <Label
                        style={{ color: colors.dorado01, textDecorationLine: "underline", fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                            window.location.href = "/reune/panel";
                        }}
                    >
                        Ir al Dashboard
                    </Label>
                </Col>
                <Col style={{ textAlign: "right" }} >
                    <Logout style={{ marginRight: 10, color: colors.dorado01 }} />
                    <Label
                        style={{ color: colors.dorado01, textDecorationLine: "underline", fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                            Swal.fire({
                                icon: "question",
                                title: "Salir del Sistema",
                                text: `¿Estas seguro de que quieres salir del sistema?`,
                                showConfirmButton: true,
                                confirmButtonColor: colors.dorado01,
                                showCancelButton: true,
                                cancelButtonText: "No",
                                confirmButtonText: "Si",
                                timerProgressBar: true,
                                reverseButtons: true,
                                timer: 10000
                            }).then(async (response) => {
                                if (response.isConfirmed) {
                                    cookies.remove("usuario");
                                    Tiempo.sleep(0.5).then(() => window.location.href = "/");
                                }
                            });
                        }}
                    >
                        Salir del Sistema
                    </Label>
                </Col>
            </Row>

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5, marginTop: 10 }} >
                <Col style={{ minWidth: "25%", width: "25%", maxWidth: "25%" }}  >
                    <FormGroup>
                        <Label style={{ color: colors.dorado01 }} >
                            Fecha Inicial
                        </Label>
                        <InputGroup>
                            <Input
                                id="fechaInicial"
                                value={fechaInicial}
                                max={fechaFinal}
                                onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                    setFechaInicial(value);
                                }}
                                style={{ ...ComponentsCSS.Input, marginTop: 0 }}
                                type="date"
                            />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col style={{ minWidth: "25%", width: "25%", maxWidth: "25%" }}  >
                    <FormGroup>
                        <Label style={{ color: colors.dorado01 }} >
                            Fecha Final
                        </Label>
                        <InputGroup>
                            <Input
                                id="fechaFinal"
                                value={fechaFinal}
                                min={fechaInicial}
                                onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                    setFechaFinal(value);
                                }}
                                style={ComponentsCSS.Input}
                                type="date"
                            />
                            <InputGroupText
                                style={ComponentsCSS.InputGroupText}
                                onClick={() => {
                                    listarConsultas(fechaInicial, fechaFinal);
                                }}
                            >
                                <Search style={{ color: colors.dorado01 }} />
                            </InputGroupText>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col style={{ textAlign: "right", minWidth: "50%", width: "50%", maxWidth: "50%" }} >
                    <IconButton style={{ marginTop: 30 }} >
                        <Add
                            style={{ color: colors.dorado01 }}
                            onClick={() => {
                                setIsOpenModalConsulta(true)
                                const data: Consulta = ConsultaModel.getEstructura();
                                setConsulta(data);
                            }}
                        />
                    </IconButton>
                    <IconButton
                        style={{ marginTop: 30, marginRight: 5 }}
                        onClick={() => {
                            listarConsultas(fechaInicial, fechaFinal);
                        }}
                    >
                        <Search style={{ color: colors.dorado01 }} />
                    </IconButton>
                </Col>
            </Row>

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5 }} >
                <Label style={{ fontWeight: "bold", fontSize: 18, color: colors.dorado01 }} >
                    Lista de consultas del {Fecha.formatDateToText(fechaInicial)} al {Fecha.formatDateToText(fechaFinal)}
                </Label>
            </Row>


            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5, marginTop: 10 }} >
                <Col>
                    <Label>
                        <i>Ultima actualización a las {labelUltimaActualizacion} <br />
                            Se listaron {consultasLista.length} consulta(s)</i>
                    </Label>
                </Col>
            </Row>

            <Row style={{ marginRight: device.isDesktop ? 50 : 5, marginLeft: device.isDesktop ? 50 : 5, marginTop: 10 }} >
                <Table
                    columns={columnsConsulta}
                    data={consultasLista}
                    noDataComponent={<Label style={{ fontWeight: "bold", fontSize: 26, color: colors.gris, marginTop: 50, textAlign: "center" }} >TABLA VACÍA</Label>}
                />
            </Row>

            <Modal
                isOpen={isOpenModalConsulta}
                style={{ maxWidth: device.isDesktop ? "90%" : "100%", fontFamily: '"Fira Sans", sans-serif' }}
            >
                <ModalHeader
                    close={
                        <IconButton
                            onClick={() => setIsOpenModalConsulta(false)}
                            style={{ backgroundColor: colors.blanco01, color: colors.dorado01 }}
                        >
                            <Close />
                        </IconButton>
                    }
                    style={{
                        backgroundColor: colors.dorado01
                    }}
                >
                    <Label style={{ color: colors.blanco01, fontSize: 24 }} >
                        DATOS PARA ENVIAR
                    </Label>
                </ModalHeader>
                <ModalBody style={{ minHeight: "70vh", maxHeight: "70vh", height: "70vh", overflowY: "auto" }} >
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "40%" : "100%", width: device.isDesktop ? "40%" : "100%", maxWidth: device.isDesktop ? "40%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Denominación o razón social
                                </Label>
                                <Input
                                    id="consulta.institucionClave"
                                    value={consulta.institucionClave}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("institucionClave", value);
                                    }}
                                    style={{ ...ComponentsCSS.Input, cursor: "not-allowed" }}
                                    disabled
                                    title={"Este dato no se puede cambiar, solo es informativo"}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "30%" : "100%", width: device.isDesktop ? "30%" : "100%", maxWidth: device.isDesktop ? "30%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Sector
                                </Label>
                                <Input
                                    id="consulta.sector"
                                    value={consulta.sector}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("sector", value);
                                    }}
                                    style={{ ...ComponentsCSS.Input, cursor: "not-allowed" }}
                                    disabled
                                    title={"Este dato no se puede cambiar, solo es informativo"}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "30%" : "100%", width: device.isDesktop ? "30%" : "100%", maxWidth: device.isDesktop ? "30%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Número de Trimestre
                                </Label>
                                <Input
                                    value={consulta.consultasTrim}
                                    type="select"
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        setConsulta((prev: Consulta) => ({ ...prev, consultasTrim: Number(value) }));
                                    }}
                                    disabled={consulta.IdConsulta > 0}
                                    style={ComponentsCSS.Input}
                                >
                                    {
                                        listaTrimestre.map((trimestre: Trimestre) => {
                                            return (<option value={trimestre.IdTrimestre}>{trimestre.trimestre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Numero de Consultas
                                </Label>
                                <Input
                                    id="consulta.numConsultas"
                                    value={consulta.numConsultas}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("numConsultas", value);
                                    }}
                                    style={{ ...ComponentsCSS.Input, cursor: "not-allowed" }}
                                    disabled
                                    title={"Este dato no se puede cambiar, solo es informativo, descuerdo a la disposición siempre el valor sera 1"}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Folio
                                </Label>
                                <Input
                                    id="consulta.consultasFolio"
                                    value={consulta.consultasFolio}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("consultasFolio", value);
                                    }}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Estatus
                                </Label>
                                <Input
                                    id="consulta.consultasEstatusCon"
                                    value={consulta.consultasEstatusCon}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("consultasEstatusCon", +value);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    <option value={1}>Pendiente</option>
                                    <option value={2}>Concluido</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de atención
                                </Label>
                                {
                                    Number(consulta.consultasEstatusCon) === 2 &&
                                    <Input
                                        id="consulta.consultasFecAten"
                                        value={consulta.consultasFecAten}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            handleConsultaData("consultasFecAten", value);
                                        }}
                                        min={consulta.consultasFecRecepcion}
                                        type={"date"}
                                        style={{ ...ComponentsCSS.Input }}
                                        disabled={consulta.IdConsulta > 0}
                                    />
                                }
                                {Number(consulta.consultasEstatusCon) === 0 && <><br /> <i>Seleccione un estatus</i></>}
                                {Number(consulta.consultasEstatusCon) === 1 && <><br /> <i>Esta dato no es necesario si el estatus esta en pendiente</i></>}
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Estado
                                </Label>
                                <Input
                                    id="consulta.estadosId"
                                    value={consulta.estadosId}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("estadosId", value);
                                        listarCiudades(+value);
                                        handleConsultaData("consultasMpioId", "0");
                                        const estado: Estado | undefined = estadosLista.find((estado: Estado) => estado.IdEstado === Number(value));
                                        if (estado) handleConsultaData("estadoDescripcion", estado.nombre);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        estadosLista.map((value: Estado) => {
                                            return (<option value={value.IdEstado}>{value.nombre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Fecha de recepción
                                </Label>
                                <Input
                                    id="consulta.consultasFecRecepcion"
                                    value={consulta.consultasFecRecepcion}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("consultasFecRecepcion", value);
                                    }}
                                    type={"date"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Medios de recepción o canal
                                </Label>
                                <Input
                                    id="consulta.mediosId"
                                    value={consulta.mediosId}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("mediosId", value);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        mediosAtencionLista.map((value: MedioAtencion) => {
                                            return (<option value={value.IdMedioAtencion}>{value.nombre}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Productos
                                </Label>
                                <Input
                                    id="consulta.producto"
                                    value={consulta.producto}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("producto", value);
                                        handleConsultaData("causaId", "0");
                                        listarCausasProductosLista(value);
                                        const producto: Producto | undefined = productosLita.find((producto: Producto) => producto.IdProducto === value);
                                        if (producto) handleConsultaData("productoDescripcion", producto.producto);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        productosLita.map((value: Producto) => {
                                            return (<option value={value.IdProducto}>{value.producto}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "40%" : "100%", width: device.isDesktop ? "40%" : "100%", maxWidth: device.isDesktop ? "40%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Causa
                                </Label>
                                <Input
                                    id="consulta.causaId"
                                    value={consulta.causaId}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("causaId", value);
                                        const causa: Causa | undefined = causasLista.find((causa: Causa) => causa.IdCausa === Number(value));
                                        if (causa) handleConsultaData("causaDescripcion", causa.causa);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        causasLista.map((value: Causa) => {
                                            return (<option value={value.IdCausa}>{value.causa}</option>)
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Código Postal
                                </Label>
                                <Input
                                    id="consulta.consultasCP"
                                    value={consulta.consultasCP}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("consultasCP", Numero.soloNumero(value));

                                    }}
                                    type={"text"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                />
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Ciudad
                                </Label>
                                <Input
                                    id="consulta.consultasMpioId"
                                    value={consulta.consultasMpioId}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("consultasMpioId", value);
                                        listarLocalidad(consulta.estadosId, Number(value));
                                        const ciudad: Ciudad | undefined = ciudadesLista.find((ciudad: Ciudad) => ciudad.IdCiudad === Number(value));
                                        if (ciudad) handleConsultaData("municipioDescripcion", ciudad.ciudad);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                >
                                    <option value="0">Seleccione una opción</option>
                                    {
                                        ciudadesLista.map((item: Ciudad) => {
                                            return (
                                                <option value={item.IdCiudad}>{item.ciudad}</option>
                                            )
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Localidad
                                </Label>
                                <Input
                                    id="consulta.consultasLocId"
                                    value={consulta.consultasLocId}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("consultasLocId", value);
                                        // const localidad: Localidad | undefined = localidadLista.find((localidad: Localidad) => localidad.IdLocalidad === Number(value));
                                        // if(localidad)handleConsultaData("consultasLocId", localidad);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                >
                                    <option value="0">Seleccione una opción</option>
                                    {
                                        localidadLista.map((item: Localidad) => {
                                            return (
                                                <option value={item.IdLocalidad}>{item.localidad}</option>
                                            )
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    Nivel de atencion
                                </Label>
                                <Input
                                    id="consulta.consultascatnivelatenId"
                                    value={consulta.consultascatnivelatenId}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("consultascatnivelatenId", Number(value));
                                        const nivelAtencion: NA | undefined = lista.find((item: NA) => item.index === Number(value));
                                        if (nivelAtencion) handleConsultaData("nivelAtencionDescripcion", nivelAtencion.label);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                >
                                    <option value={0}>Seleccione una opción</option>
                                    {
                                        lista.map((item: NA) => {
                                            return (
                                                <option value={item.index}>{item.label}</option>
                                            )
                                        })
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: device.isDesktop ? "20%" : "100%", width: device.isDesktop ? "20%" : "100%", maxWidth: device.isDesktop ? "20%" : "100%" }} >
                            <FormGroup>
                                <Label style={{ color: colors.dorado01, fontWeight: "bold" }} >
                                    PORI
                                </Label>
                                <Input
                                    id="consulta.consultasPori"
                                    value={consulta.consultasPori}
                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                        handleConsultaData("consultasPori", value);
                                    }}
                                    type={"select"}
                                    style={{ ...ComponentsCSS.Input }}
                                    disabled={consulta.IdConsulta > 0}
                                >
                                    <option value="SI">SI</option>
                                    <option value="NO">NO</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    {
                        consulta.IdConsulta === 0 &&
                        <Button
                            style={{ backgroundColor: colors.blanco01, borderColor: colors.dorado01, color: colors.dorado01, fontWeight: "bold", boxShadow: "none" }}
                            onClick={() => {
                                enviarConsulta();
                            }}
                        >
                            Enviar
                        </Button>
                    }
                </ModalFooter>
            </Modal>
            <Modal
                isOpen={isOpenModalErrors}
                style={{ maxWidth: device.isDesktop ? "50%" : "100%", fontFamily: '"Fira Sans", sans-serif' }}
            >
                <ModalHeader
                    close={
                        <IconButton
                            onClick={() => setIsOpenModalErrors(false)}
                            style={{ backgroundColor: colors.blanco01, color: colors.dorado01 }}
                        >
                            <Close />
                        </IconButton>
                    }
                    style={{
                        backgroundColor: colors.dorado01
                    }}
                >
                    <Label style={{ color: colors.blanco01, fontSize: 24 }} >
                        ERRORES DETECTADOS
                    </Label>
                </ModalHeader>
                <ModalBody style={{ minHeight: "70vh", maxHeight: "70vh", height: "70vh", overflowY: "auto" }} >
                    {
                        arrayErrors.map((label: string, index: number) => {
                            return (
                                <>
                                    <Row style={{ marginLeft: 20, marginRight: 0 }} >
                                        <Col>
                                            <Label>
                                                {index + 1}{'.- '}{label}
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            )
                        })
                    }
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ backgroundColor: colors.blanco01, borderColor: colors.dorado01, color: colors.dorado01, fontWeight: "bold", boxShadow: "none" }}
                        onClick={() => setIsOpenModalErrors(false)}
                    >
                        Cerrar
                    </Button>

                </ModalFooter>
            </Modal>

        </section >
    );
}

export default ConsultasIndex;